module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/vendor-mobile-9dbb42d58f898260f0f5596b8788baa9.jpg";